// Statuses a retry cannot improve, read by every web app's QueryClient default.
//
// 429 is here because retrying a rate limit is what makes it worse: the public
// onboarding routes share a 60-per-minute budget keyed on the invitation token,
// and three automatic retries spent the applicant's next window on a page that
// was already being refused.
export const appErrorCodes = new Set([400, 401, 403, 404, 429])

export const UPLOADS_ERROR_CODES = {
  GENERIC_ERROR: 'GENERIC_ERROR',
  ZOD_SCHEMA_ERROR: 'ZOD_SCHEMA_ERROR',
}

export type AppUploadsErrorCode = keyof typeof UPLOADS_ERROR_CODES
